export default __webpack_public_path__ + "static/media/contacts.be654d0f.svg";